import React from 'react';
import {
    defineBlock,
    smartProps,
    EditableDiv,
    useEditor,
} from '@smartfire/gutenberg-react';
import style from './block.module.scss';

function Block({ title, link, buttonText, disposition, separateur }) {
    const { isEditing } = useEditor();
    return (
        <div className="content-container">
            <div className="block-container">
                <div className={isEditing ? style.admin : style.block}>
                    <div>
                        <div className={style.left}>
                            {isEditing ? (
                                <EditableDiv
                                    className={style.title}
                                    smartProp="title"
                                    placeholder={'Entrez un titre'}
                                />
                            ) : (
                                <h1 className={style.title}>{title}</h1>
                            )}
                            <EditableDiv
                                className={style.text}
                                formattingControls={['bold', 'italic', 'link']}
                                smartProp="text"
                                placeholder={'Entrez un texte'}
                            />
                        </div>
                    </div>
                    <div className={style.right}>
                        <EditableDiv
                            className={style.title}
                            smartProp="title2"
                            placeholder={'Entrez un titre'}
                        />
                        <EditableDiv
                            className={style.text}
                            formattingControls={['bold', 'italic', 'link']}
                            smartProp="text2"
                            placeholder={'Entrez un texte'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        title2: smartProps.string.withDefault(''),
        text2: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Nouveau cas client',
    },
});
